<div class="signup__button-container">
  <button mat-raised-button class="button--secondary" [routerLink]="['/']">Back to home</button>
</div>

<h2 class="comreg-accent">Sign Up</h2>
<form [formGroup]="mainForm" (ngSubmit)="handleSubmit()">
  @if (!isSubmitted) {
    <mat-stepper #stepper linear formArrayName="steps" class="stepper">
      <mat-step formGroupName="0" [stepControl]="steps.get([0])">
        <ng-template matStepLabel>Provide organisation details</ng-template>

        <h2>Organisation details</h2>
        <div class="signup__container">
          <p>
            If you are an organisation (company, club, charity etc) that sends SMS message, wishing to apply for your own SMS Sender ID(s) please select "I'm applying to be a Sender ID Owner".
          </p>
          <p>
            If you are an SMS Provider that carries SMS messages on behalf of businesses please select "I'm applying to be a Participating Aggregator/Mobile Service Provider".
          </p>

          <si-registration-form
            [orgTypes]="orgTypes"
            [countries]="countries"
            [accountTypes]="accountTypes"
            [showSubmitButton]="false"
          ></si-registration-form>
        </div>
        <div class="signup__step__navigation">
          <button mat-button mat-raised-button type="button" disabled>Previous</button>
          <button mat-raised-button matStepperNext (click)="handleNextButtonClick()" type="button">Next</button>
        </div>
      </mat-step>

      <mat-step formGroupName="1" [stepControl]="steps.get([1])">
        <ng-template matStepLabel>(Optional) Request Sender IDs</ng-template>

        <h2>(Optional) Request Sender IDs</h2>
        <div class="signup__container">
          <div class="signup__container__border-wrapper">
            <div class="signup__step__content--thin">
              <h3>Request Sender IDs</h3>
              <p>
                You may apply for Sender ID(s) now or after your Account has been activated.
              </p>
              <si-sender-ids-form
                [thirdParties]="thirdParties$ | async"
                (thirdPartiesChanged)="handleThirdPartiesChanged($event)"
                [signUpPage]="true"
              ></si-sender-ids-form>
            </div>
          </div>
        </div>
        <div class="signup__step__navigation">
          <button mat-button matStepperPrevious type="button">Previous</button>
          <button mat-raised-button matStepperNext type="button" (click)="handleGoToPickOpas()">Next</button>
        </div>
      </mat-step>

      @if (!disablePickOpasStep) {
        <mat-step formGroupName="2" [stepControl]="steps.get([2])">
          <ng-template matStepLabel>Select OPAs</ng-template>
  
          <h2>Select OPAs</h2>
          <div class="signup__container">
            <div class="signup__container__border-wrapper">
              <div>
                <h3>Select OPAs</h3>
                <si-sender-ids-opas-form [formArray]="steps.get([2])" [opas]="opas$ | async" [disabled]="disablePickOpasStep"></si-sender-ids-opas-form>
              </div>
            </div>
          </div>
          <div class="signup__step__navigation">
            <button mat-button matStepperPrevious type="button">Previous</button>
            <button mat-raised-button matStepperNext type="button" (click)="handleGoToPickOpas()">Next</button>
          </div>
        </mat-step>
      }

      <mat-step formGroupName="3" [stepControl]="steps.get([3])">
        <ng-template matStepLabel>Declaration</ng-template>

        <h2>Declaration</h2>
        <div class="signup__container signup__declaration">
          <div>
            <p>
              Once you have Submitted your details, ComReg will review your application.
            </p>
            <p>
              We will use your contact email address to communicate with you.
            </p>
          </div>
          <si-signup-declaration [formGroup]="signupDeclarationForm" [accountType]="accountType"></si-signup-declaration>
          <form [formGroup]="recaptchaForm">
            <re-captcha #captchaRef="reCaptcha" [siteKey]="siteId" formControlName="recaptcha" (resolved)="handleCaptchaResolve($event)"> </re-captcha>
          </form>

          @if (errorMessage) {
            <p class="signup__error">{{ errorMessage }}</p>
          }
        </div>
        <div class="signup__step__navigation">
          <button mat-button matStepperPrevious type="button">Previous</button>
          <button mat-raised-button class="button--accent">Submit</button>
        </div>
      </mat-step>
    </mat-stepper>
  } @else {
    <div class="signup__container">
      <div class="signup__success">
        @if (hasFile) {
          <p>Thank you for your registration, ComReg will analyse your documentation</p>
        } @else {
          <p>Thank you for your registration</p>
        }
        <button mat-raised-button routerLinkActive routerLink="/">Go back</button>
      </div>
    </div>
  }
</form>
